import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "toast-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "toast-icon" }, null, -1)
const _hoisted_3 = { class: "toast-message" }
const _hoisted_4 = { class: "bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_RichTekst = _resolveComponent("RichTekst")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['toast toast-info d-print-none', _ctx.showSessionExpirationToast ? 'show' : 'hide']),
      id: "session-expiration-toast",
      role: "status"
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.session-timeout.titel' }, null, 8, ["tekstNoegle"])
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_RichTekst, { tekstNoegle: 'tco.sidehoved.session-timeout.beskrivelse' }, null, 8, ["tekstNoegle"])
        ]),
        _hoisted_5,
        _createElementVNode("p", null, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.session-timeout.udloeb-label' }, null, 8, ["tekstNoegle"]),
          _hoisted_6,
          _createElementVNode("strong", null, _toDisplayString(_ctx.sessionExpirationTime), 1)
        ]),
        _hoisted_7,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshLogin())),
          class: "button button-secondary d-print-none",
          id: "login-refresh-button"
        }, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.knap.forny-session' }, null, 8, ["tekstNoegle"])
        ]),
        _createElementVNode("button", {
          class: "button button-secondary d-print-none",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout())),
          id: "logout-notification-button"
        }, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.sidehoved.knap.log-af' }, null, 8, ["tekstNoegle"])
        ])
      ])
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toastMessages, (tm) => {
      return (_openBlock(), _createBlock(_component_Toast, {
        key: tm,
        toast: tm
      }, null, 8, ["toast"]))
    }), 128))
  ]))
}